import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <p>© 2024</p>
      <p>
        @{" "}
        <a
          href="https://lucie-sedlakova.cz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Lucie Jagošová
        </a>
      </p>
    </div>
  );
};

export default Footer;
